import { createContext, PropsWithChildren, useContext } from 'react';

const PlenaryLessonContextId = createContext<string | null>(null);

type PlenaryLessonContextIdProviderProps = PropsWithChildren<{ contextId: string | null }>;

export function PlenaryLessonContextIdProvider(props: PlenaryLessonContextIdProviderProps) {
  const { contextId, children } = props;

  return <PlenaryLessonContextId.Provider value={contextId}>{children}</PlenaryLessonContextId.Provider>;
}

export function usePlenaryContextId() {
  const context = useContext(PlenaryLessonContextId);
  return context;
}
